import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  deleteLeaveRequest: ["leave_id"],
  deleteLeaveSuccess: ["Status"],
  deleteLeaveFailure: null,
});

export const DeleteLeaveTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  leave_id: null,
  fetching: null,
  success: null,
  error: null,
  Status: null,
});

export const DeleteLeaveSelectors = {
  getData: (state: any) => state.deleteLeave.data,
  isFetching: (state: any) => state.deleteLeave.fetching,
  isSuccess: (state: any) => state.deleteLeave.success,
  hasError: (state: any) => state.deleteLeave.error,
};

export const request = (state: any, { leave_id }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    leave_id: leave_id,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { Status } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    Status,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    goal: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.DELETE_LEAVE_REQUEST]: request,
  [Types.DELETE_LEAVE_SUCCESS]: success,
  [Types.DELETE_LEAVE_FAILURE]: failure,
});
